module.exports = __webpack_public_path__ + "img/no_task2888.4aa8ef42.png";